import { useState, useEffect, useRef } from "react"
import { useAddNewHepExerciseMutation } from "./hepexercisesApiSlice"
import { useGetFavoritesQuery} from "../exercises/exercisesApiSlice"
import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faSearch, faRefresh, faHeart } from "@fortawesome/free-solid-svg-icons"
import { toast } from 'react-toastify'
import useAuth from '../../hooks/useAuth'


const NewHepExerciseForm = ({ id, exercises, exercisetypes, bodyparts }) => {

	const navigate = useNavigate()
	const dropdownRef = useRef(null)
	const { userId } = useAuth()
	
	const [exercise_id, setExerciseId] = useState('')
	const [hep_id, setHepId] = useState(id)
	const [description, setDescription] = useState('')


	// add exercise
	const [addNewHepExercise, {
		isSuccess,
		isError,
		error
	}] = useAddNewHepExerciseMutation()


	useEffect(() => {
		if (isSuccess) {
			setExerciseId('')
			setHepId('')
			setDescription('')
			setBodypart('')
            setExercisetype('')
			toast.success("Exercise was Added to HEP");
			navigate(`/dash/hep/${hep_id}`)
		}

		if (isError) {
			toast.error(error?.data?.message);
		}
	}, [isSuccess, navigate, isError, error, hep_id])

	// get favorites
	const { favorites } = useGetFavoritesQuery(userId, {
        selectFromResult: ({ data }) => ({
            favorites: data?.ids.map(id => data?.entities[id])
        }),
    })


	// field changes
	const onExerciseIdChanged = e => setExerciseId(e.target.value)
	const onDescriptionChanged = e => setDescription(e.target.value)


	//search
	const [search, setSearch] = useState('')
	const [searchResults, setSearchResults] = useState(exercises);
    const onSearchClicked= () =>{
		// filter exercises, based on search string
		const filteredResults = exercises.filter(item =>
			item.exercise_name.toLowerCase().includes(search.toLowerCase())
		)
		setSearchResults(filteredResults)
		setBodypart('')
		setExercisetype('')
		dropdownRef.current.focus()
	}

	const onAllClicked= () =>{
		setSearchResults(exercises);
		setBodypart('')
		setExercisetype('')
		dropdownRef.current.focus()
	}

	const onFavoriteClicked= () =>{
		// filter exercises, based on favorites
		const filteredArray = exercises.filter(item1 => favorites.some(item2 => item2.exercise_id === item1.id));
		setSearchResults(filteredArray)
		setBodypart('')
		setExercisetype('')
		dropdownRef.current.focus()
	}



	// filters
	const [body_part, setBodypart] = useState('')
    const [exercise_type, setExercisetype] = useState('')

    const onBodypartChanged = (e) => {
		setBodypart(e.target.value)
	}
    const onExercisetypeChanged= (e) => {
		setExercisetype(e.target.value)
	}

	useEffect(() => {
		const FilteredData = exercises.filter(item => {
			const matchesBP = body_part === '' || item.body_part === body_part
			const matchesET = exercise_type === '' || item.exercise_type === exercise_type
			return matchesBP && matchesET
		});
		setSearchResults(FilteredData)
		dropdownRef.current.focus()
		
	  }, [body_part, exercise_type, exercises]);





	// add exercise to HEP
	let canSave
	canSave = [description.length, exercise_id.length].every(Boolean)

	const onSaveExerciseClicked = async (e) => {
		e.preventDefault()
		if (canSave) {
			await addNewHepExercise({ exercise_id, hep_id, description })
		} else {
			toast.error('All Fields are Required');
		}

	}



	// set options for drop down boxes
	let options=null
	options = searchResults.map(exercise => {
		return (
			<option key={exercise.id} value={exercise.id}>
				{exercise.exercise_name}
			</option >
		)
	})

	const optionsBP = bodyparts.map(bodypart => {
        return (
            <option key={bodypart.id} value={bodypart.id}>
                {bodypart.bodypart}
            </option >
        )
    })

    const optionsET = exercisetypes.map(exercisetype => {
        return (
            <option key={exercisetype.id} value={exercisetype.id}>
                {exercisetype.exercisetype}
            </option >
        )
    })


	let content
	content = (
		<section id="main_content">
			<header>
				<h1 className="text-steel mt-5">
					Add Exercise to HEP
				</h1>
			</header>
			<main>
				<div className="row mt-5">
					<div className="col-md-3">
						<label className="form-label" htmlFor="exercise">Search or use Filter</label>
						<input type='text' className="form-control" 
						id="exercise"
						onChange={(e) => setSearch(e.target.value)}
						/>
					</div>
					<div className="col-md-3 text-end mt-1">
						<br />
						<button className="btn btn-steel m-1" onClick={onSearchClicked} title="Search"><FontAwesomeIcon icon={faSearch} /></button>
						<button className="btn btn-steel m-1" onClick={onFavoriteClicked} title="Show Favorites"><FontAwesomeIcon icon={faHeart} /></button>
						<button className="btn btn-steel m-1" onClick={onAllClicked} title="Show All"><FontAwesomeIcon icon={faRefresh} /></button>
					</div>
					<div className="col-md-3">
                            <label className="form-label" htmlFor="body_part">
                                Filter Region:
                            </label>
                            <select
                                id="body_part"
                                name="body_part"
                                className="form-select"
                                value={body_part}
                                onChange={onBodypartChanged}
                            >
								<option value=''>All Regions</option>
                                {optionsBP}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label" htmlFor="exercise_type">
                                And/ Or Type:
                            </label>
                            <select
                                id="exercise_type"
                                name="exercise_type"
                                className="form-select"
                                value={exercise_type}
                                onChange={onExercisetypeChanged}
                            >
								<option value=''>All Types</option>
                                {optionsET}
                            </select>
                        </div>

				</div>

				<form onSubmit={e => e.preventDefault()}>
					<div className="row mb-3 mt-5">
						<div className="col-md-6">
							<label className="form-label" htmlFor="exercise_id">
								Add Exercise:
							</label>
							<select
								id="exercise_id"
								name="exercise_id"
								className="form-select"
								value={exercise_id}
								onChange={onExerciseIdChanged}
								ref={dropdownRef}
							>
								<option value=''>Select</option>
								{options}
							</select>
						</div>
						<div className="col-md-6">
							<label className="form-label" htmlFor="exercise_details">
								Details:
							</label>
							<textarea
								className="form-control"
								id="description"
								rows="5"
								name="text"
								value={description}
								onChange={onDescriptionChanged}
							/>
						</div>
					</div>
					<div className="row mb-3">
					</div>

					<div className="row mb-3">
						<div className="col-md-12 text-end">
							<span
								role="button"
								className="text-success p-2 icon"
								title="Save"
								onClick={onSaveExerciseClicked}
							>
								Add Exercise to HEP
								<FontAwesomeIcon icon={faSave} style={{ marginLeft: '5px' }} />
							</span>

						</div>
					</div>
				</form>
			</main>
		</section>

	)

	return content


}

export default NewHepExerciseForm